<template>
  <div class="grid">
    <div class="col col-login">
      <img
        :src="ondatoLogo"
        :alt="$t('login.ondato_logo')"
        class="logo-ondato"
      />
      <div class="welcome">
        <h1>{{ $t("login.welcome") }}</h1>
        <ui-button
          class="login-btn"
          variant="primary"
          @click="login"
          size="lg"
          block
        >
          Login
        </ui-button>
        <p v-if="errorText" class="error-text">
          {{ errorText }}
        </p>
      </div>
    </div>
    <div class="col col-illustration">
      <img
        :src="arbitriumLogo"
        :alt="$t('login.arbitrium_logo')"
        class="logo-arbitrium"
      />
    </div>
  </div>
</template>

<script>
import arbitriumLogo from "@/assets/arbitrium.png";
import ondatoLogo from "@/assets/ondato.png";
import { userManager } from "@/utils/identity";
import { parseQueryError } from "@/utils/queryError";
export default {
  computed: {
    arbitriumLogo() {
      return arbitriumLogo;
    },
    ondatoLogo() {
      return ondatoLogo;
    },
    errorText() {
      const { name, message } = parseQueryError(this.$route.query);
      const errorText = [];
      if (name) errorText.push(name);
      if (message) errorText.push(message);
      return errorText.join(": ");
    }
  },
  methods: {
    login() {
      userManager.signinRedirect();
    }
  }
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-areas:
    "illustration"
    "login";
  grid-template-columns: 100%;
  min-height: 100vh;
  text-align: center;

  @media all and (min-width: 60rem) {
    grid-template-areas: "login illustration";
    grid-template-columns: 1fr 1fr;
  }
}
.col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--theme-contrast);
}
.col-login {
  display: flex;
  grid-area: login;
  justify-content: space-evenly;
  text-align: center;
}
.col-illustration {
  position: relative;
  grid-area: illustration;
  overflow: hidden;
  color: var(--button-primary-text-color);
  background: var(--button-primary-background);

  @media all and (min-width: 60rem) and (min-height: 40rem) {
    &::before {
      position: absolute;
      right: 3rem;
      bottom: 3rem;
      box-sizing: border-box;
      width: 20rem;
      height: 20rem;
      content: "";
      border: 3.5rem solid var(--white);
      border-right-color: transparent;
      border-bottom-color: transparent;
      border-radius: 50%;
      transform: translateY(50%) rotate(45deg);
    }
  }
}
.logo-arbitrium {
  display: block;
  width: auto;
  max-width: 20rem;
  max-height: 40vh;
}
.logo-ondato {
  display: block;
  width: auto;
  max-width: 20rem;
  max-height: 40vh;
}
.login-btn {
  width: 100%;
  max-width: 20rem;
}
.error-text {
  color: var(--text-danger);
}
</style>
